import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Box } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import SingleImageUploader from 'src/components/uploads/image-uploader';
import SubmitButton, { useCustomFormik } from 'src/components/formik-helper';
import StringTextField from 'src/components/widgets/string-textfield';
import TimeTextField from 'src/components/widgets/time-field';
import DateAndTimePicker from 'src/components/widgets/date-time-picker';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import DropdownLegalPlates from 'src/components/dropdown/dropdown-plates-legal';
import QuillEditor from 'src/components/quill-editor';
import { getCacheCarPartner } from 'src/utils/cache-data';
import { useTranslation } from 'react-i18next';
import { appStr } from 'src/locales/app_strings';
import {
  initialValues,
  validationSchema,
  handleSubmitted,
} from './formik';

export const DetailForm = ({ item, apiCreate, apiUpdate, apiRemove }) => {
  const [deviceSerialHint, setDeviceSerialHint] = useState('');
  const { t } = useTranslation();

  const formik = useCustomFormik({
    // validationSchema: validationSchema(item),

    onSubmit: async (values, helpers) => {
      await handleSubmitted(values, item, apiCreate, apiUpdate, apiRemove);
    },
  });
  
  useEffect(() => {
    initialValues(formik, item);

    if (item) {
      const carId = formik.values?.plateField?.value;
      if(carId){
        const partners = getCacheCarPartner();
        const cache = partners[carId];
        if (cache) {
          const card = cache.xd.cardNumber;
          if(card){
            item.currentCard = card;
          }
        }
      }
    } 
  }, [item]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <Card>
        <CardContent sx={{ px: 1, py: 2 }}>
          <Grid container spacing={3} alignItems="flex-start">
            <Grid container spacing={3} xs={12} md={6}>
              <Grid xs={12} md={4}>
                <StringTextField
                  label="Mã học viên"
                  name="studentCode"
                  formik={formik}
                  hintValue={item.studentCode}
                />
              </Grid>

              <Grid xs={12} md={8}>
                <StringTextField
                  label="Tên học viên"
                  name="studentName"
                  formik={formik}
                  hintValue={item.studentName}
                />
              </Grid>

              <Grid xs={12} md={12}>
                <Box sx={{ display: 'flex', gap: 3, alignItems: 'center' }}>
                  <Box sx={{ flex: 1 }}>
                    <StringTextField
                      label="Số điện thoại"
                      name="studentPhone"
                      formik={formik}
                      hintValue={item?.quantity}
                    />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <StringTextField
                      label="Ngày sinh"
                      name="studentBirthday"
                      formik={formik}
                      hintValue={item?.quantity}
                  />
                  </Box>
                </Box>
              </Grid>

              <Grid xs={12} md={12}>
                <Box sx={{ display: 'flex', gap: 3, alignItems: 'center' }}>
                  <Box sx={{ flex: 1 }}>
                    <StringTextField
                      label="Khóa học"
                      name="course"
                      formik={formik}
                      hintValue={item?.quantity}
                    />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <StringTextField
                      label={t(appStr.txt_073)}
                      name="carType"
                      formik={formik}
                      hintValue={item?.quantity}
                    />
                  </Box>
                </Box>
              </Grid>

              <Grid xs={12} md={12}>
                <Box sx={{ display: 'flex', gap: 3, alignItems: 'center' }}>
                  <Box sx={{ flex: 1 }}>
                    <DateAndTimePicker
                      label="Bắt đầu lúc"
                      name="beginAt"
                      format="dd/MM/yyyy - HH:mm"
                      formik={formik}
                      // hintValue={item.bookingAt || nextTime}
                    >
                      <MobileDateTimePicker ampm={false} />
                    </DateAndTimePicker>
                  </Box>
                  <Box sx={{ flex: '0 0 auto', textAlign: 'right' }}>
                    <TimeTextField />
                  </Box>
                </Box>
              </Grid>


              <Grid xs={12} md={4}>
                <StringTextField
                  label="Mã giáo viên"
                  name="teacherCode"
                  formik={formik}
                  hintValue={item?.quantity}
                />
              </Grid>

              <Grid xs={12} md={8}>
                <StringTextField
                  label="Tên giáo viên"
                  name="teacherName"
                  formik={formik}
                  hintValue={item?.quantity}
                />
              </Grid>

              <Grid xs={12} md={12}>
                <Box sx={{ display: 'flex', gap: 3, alignItems: 'center' }}>
                  <Box sx={{ flex: 1 }}>
                    <DropdownLegalPlates
                      formik={formik}
                      hintValue={item?.car?.name}
                      onCallback={(val) => {
                       
                        // Update deviceSerial data from val
                        if (val) {
                          // formik.setFieldValue('deviceSerial', val);
                        }
                        setDeviceSerialHint(`${val}`);
                      }}
                    />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <StringTextField
                        label="Mã máy"
                        name="deviceSerial"
                        formik={formik}
                        hintValue={deviceSerialHint}
                      />
                    </Box>
                </Box>
              </Grid>

    

            </Grid>
            <Grid xs={12} md={6}>
              <div>
              <Grid container spacing={3}>
                <Grid xs={12}>
                  <QuillEditor
                    name="note"
                    value={formik.values.note}
                    onChange={(content) => formik.setFieldValue('note', content)}
                    placeholder='Ghi chú nếu có'
                    sx={{ height: 85 }}
                  />
                </Grid>
                <Grid xs={12}>
                  <SingleImageUploader formik={formik} />
                </Grid>
              </Grid>
              </div>
            </Grid>
          </Grid>
        </CardContent>

        <SubmitButton formik={formik} isRemove={item || false} />
      </Card>
    </form>
  );
};

DetailForm.propTypes = {
  item: PropTypes.object.isRequired,
  apiCreate: PropTypes.func,
  apiUpdate: PropTypes.func,
  apiRemove: PropTypes.func,
};
